module.exports = __webpack_public_path__ + "img/caijingLOGO.3651a401.png";